import styled from '@/styles';

export const Frame = styled('section', {
  backgroundColor: '#FFFFFF',
  border: '1px solid #DADADA',
  borderRadius: '8px',
});

export const Toolbar = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '12px',
  alignItems: 'center',
  marginBottom: '20px',
});

export const FilterLabel = styled('label', {
  display: 'flex',
  gap: '6px',
  alignItems: 'center',
  color: '#3D3D3D',
  fontSize: '13px',
});

export const Select = styled('select', {
  font: 'inherit',
  fontSize: '14px',
  border: '1px solid #BDBDBD',
  borderRadius: '6px',
  padding: '8px 10px',
  backgroundColor: '#FFFFFF',
  color: '#1E1E1E',
});

export const Segment = styled('div', {
  display: 'inline-flex',
  border: '1px solid #DADADA',
  borderRadius: '8px',
  overflow: 'hidden',
  backgroundColor: '#FFFFFF',
  '& button': {
    font: 'inherit',
    fontSize: '14px',
    border: 'none',
    borderRight: '1px solid #DADADA',
    backgroundColor: '#FFFFFF',
    padding: '8px 14px',
    cursor: 'pointer',
    color: '#3D3D3D',
    minHeight: '36px',
  },
  '& button:last-child': { borderRight: 'none' },
  '& button[aria-pressed="true"]': {
    backgroundColor: '#1E8E3E',
    color: '#FFFFFF',
    fontWeight: 600,
  },
});

export const Notice = styled('div', {
  borderRadius: '6px',
  padding: '10px 12px',
  fontSize: '14px',
  variants: {
    tone: {
      red: { backgroundColor: '#FFDFD8', color: '#8A0208' },
      green: { backgroundColor: '#E7F4E6', color: '#17722F' },
      grey: { backgroundColor: '#EDEDED', color: '#3D3D3D' },
    },
  },
});
